import { getProductsCategories } from '../getProductsCategories';
import useIonicToast from '../../../hooks/useIonicToast';

export default function useProductCategory() {
  const { presentIonToast } = useIonicToast();

  ///FUNCTION FOR GETTING AVAILABLE CATEGORIES
  const getProductCategories = async (query?: string) => {
    try {
      const res = await getProductsCategories(query?.trim());
      return res;
    } catch (error: any) {
      presentIonToast(error.message, 'error');
    }
  };

  return getProductCategories;
}
